module.exports = __webpack_public_path__ + "img/1.9ec2449a.png";